import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'lib-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  exportAs: 'libLogo',
})
export class LogoComponent implements OnInit {
  @Input() variant: 'icon' | 'wordmark' = 'wordmark';

  @Input() theme?:
    | 'primary'
    | 'accent'
    | 'warn'
    | 'link'
    | 'reverse' = undefined;

  ngOnInit(): void { }
}
